export default {
    default: {
        fetchModelsPeriod: 60000
    },
    listModels: {
        motor: {
            url: 'motor/',
            filter: {
                archived: false
            }
        },
        entity: {
            url: 'entity/',
        },
        user: {
            url: 'user/',
        },
        site: {
            url: 'site/',
            filter: {
                ordering: '-creation_date',
                is_archived: false
            }
        },
        audit: {
            url: 'audit/',
            filter: {ordering: '-creation_date'}
        },

        motorAge: {
            url: 'motor-age/',
            filter: {ordering: 'order'},
        },
        motorApplication: {
            url: 'motor-application/',
            filter: {ordering: 'order'},
        },
        motorNeed: {
            url: 'motor-need/',
            filter: {ordering: 'order'},
        },
        motorRegulationDetail: {
            url: 'motor-regulation-detail/',
            filter: {ordering: 'order'},
        },
        motorTechnology: {
            url: 'motor-technology/',
            filter: {ordering: 'order'},
        },
        motorUsage: {
            url: 'motor-usage/',
            filter: {ordering: 'order'},
        },
        generateFileRequest: {
            url: 'generate-file-request/',
            fetch: false,
        },
    }
};



// WEBPACK FOOTER //
// ./src/store/meta.js